import { render, staticRenderFns } from "./MgrupoenvasadoForm.vue?vue&type=template&id=11b5d7d8"
import script from "./MgrupoenvasadoForm.vue?vue&type=script&lang=js"
export * from "./MgrupoenvasadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports